"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampoLink = exports.LinkTarget = exports.LinkType = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
var LinkType;
(function (LinkType) {
    LinkType["Link"] = "link";
    LinkType["Link_footer"] = "link";
    LinkType["Black_link"] = "link_black";
    LinkType["Icon_link"] = "link_icon";
    LinkType["Icon_link_between"] = "link_icon d-flex align-items-center justify-content-between";
    LinkType["Button_link"] = "link_button";
    LinkType["Download_link_with_type"] = "link_icon_type";
    LinkType["Download_link_with_type_under"] = "link_icon_type_under";
    LinkType["Document_liftup_icon"] = "link_document_liftup_icon";
    LinkType["Link_listing"] = "link_listing";
    LinkType["Link_listing_with_border"] = "link_listing_with_border";
    LinkType["Link_with_selectable_icon_front"] = "link iconFront";
    LinkType["Are_you_looking_for_these_link"] = "link_looking";
    LinkType["Outline_Button"] = "btn btn-sampo-outline-primary ";
    LinkType["Primary_button"] = "btn btn-sampo-primary";
    LinkType["Transparent_button"] = "btn btn-sampo-transparent-white";
    LinkType["Transparent_button_blue"] = "btn btn-sampo-transparent-blue";
    LinkType["Icon_link_with_underline"] = "link_icon_underline";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
var LinkTarget;
(function (LinkTarget) {
    LinkTarget["New_window"] = "_blank";
    LinkTarget["Current_window"] = "_self";
})(LinkTarget = exports.LinkTarget || (exports.LinkTarget = {}));
/**
 * Sampo Link
 * @param props
 * type: Linktype
 * href: string
 * title: string
 * target: LinkTarget
 * documentType: string - (pdf, xls, etc.)
 * documents: LinkListDocument[] - Mandatory with Link_listing
 * icon_class: string - Use sampo-icon classes. Used with Selectable icon links (Icon_link_with_underline, Link_with_selectable_icon_front)
 * icon_front: boolean - true = icon front of text, otherwise end of text
 * download: adds download attribute to anchor
 * lineHeight: possibility to create links with lineheight more than one row. Used if one link has short name and others in same group have long ones.
 * additionalCssClasses: Additional classes for anchor tag.
 *
 * @returns
 */
const SampoLink = (props) => {
    var _a, _b;
    const lang = (0, react_redux_1.useSelector)((state) => {
        var _a;
        return (_a = state.OptiContentCloud) === null || _a === void 0 ? void 0 : _a.currentLanguage;
    });
    let link = react_1.default.createElement(react_1.default.Fragment, null);
    if ((props.type === LinkType.Link_listing || props.type === LinkType.Link_listing_with_border) && (((_a = props.documents) === null || _a === void 0 ? void 0 : _a.length) > 0 || props.href !== null)) {
        // listing
        const links = [];
        if (((_b = props.documents) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            props.documents.forEach((document, index) => {
                let doctype = document.href.substring(document.href.lastIndexOf('.') + 1);
                const queryparameterIndex = doctype.indexOf('?');
                if (queryparameterIndex > 0) {
                    doctype = doctype.substring(0, queryparameterIndex);
                }
                const linkProps = {
                    target: doctype.toLowerCase() === 'html' ? LinkTarget.New_window : props.target,
                    className: `d-inline-flex flex-column align-items-center text-uppercase px-2 ${props.additionalCssClasses !== undefined && props.additionalCssClasses.length > 0 ? props.additionalCssClasses.join(' ') : ''}`,
                    href: document.href,
                    key: `link.${props.title}.${props.href}.${doctype}.${index.toString()}`,
                    lang: props.blockLang && props.blockLang !== '' ? props.blockLang : null,
                    'aria-label': props.ariaLabel && props.ariaLabel !== '' ? props.ariaLabel : null
                };
                if (props.download && doctype.toLowerCase() !== 'html')
                    linkProps.download = true;
                const accessibilitytext = linkProps.download ? (lang === 'en' ? 'download' : 'lataa') : (lang === 'en' ? 'open' : 'avaa');
                links.push(react_1.default.createElement("a", Object.assign({}, linkProps),
                    react_1.default.createElement("span", { className: 'visually-hidden' }, `${accessibilitytext} ${doctype}: ${props.title}`),
                    react_1.default.createElement("span", { className: 'icon-download d-block' }),
                    react_1.default.createElement("span", { className: 'type' }, doctype)));
            });
        }
        else {
            const linkProps = {
                target: props.target,
                className: `d-inline-flex flex-column align-items-center text-uppercase border-0 px-2 ${props.additionalCssClasses !== undefined && props.additionalCssClasses.length > 0 ? props.additionalCssClasses.join(' ') : ''}`,
                href: props.href,
                key: `link.${props.title}.${props.href}}`,
                lang: props.blockLang && props.blockLang !== '' ? props.blockLang : null,
                'aria-label': props.ariaLabel && props.ariaLabel !== '' ? props.ariaLabel : null
            };
            if (props.download)
                linkProps.download = true;
            const accessibilitytext = linkProps.download ? (lang === 'en' ? 'download' : 'lataa') : (lang === 'en' ? 'open' : 'avaa');
            links.push(react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", { className: 'visually-hidden' }, `${accessibilitytext}: ${props.title}`),
                react_1.default.createElement("span", { className: 'icon-arrow-right-tail d-block' })));
        }
        const padding = props.type === LinkType.Link_listing ? 'p-3' : 'py-3';
        const width = props.type === LinkType.Link_listing_with_border ? 'w-100' : '';
        link = react_1.default.createElement("div", { className: `${props.type} ${width} ${padding} d-inline-flex align-items-center` },
            react_1.default.createElement("span", { className: 'title' }, props.title),
            react_1.default.createElement("span", { className: 'd-flex' }, links));
    }
    else if (props.href !== null) {
        let url;
        try {
            url = new URL(props.href);
        }
        catch (_c) {
            console.error(`Invalid url. Title is "${props.title}" and url ${props.href}`);
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        let offDomain = true;
        try {
            if (window.location.protocol !== url.protocol && window.location.host === url.host)
                url.protocol = window.location.protocol;
            offDomain = window.location.host !== url.host;
        }
        catch (e) {
            // Ignored on purpose
        }
        const linkProps = {
            target: props.target,
            className: `${props.type} ${props.additionalCssClasses !== undefined && props.additionalCssClasses.length > 0 ? props.additionalCssClasses.join(' ') : ''}`,
            href: url.href,
            key: `link.${props.title}.${props.href}`,
            lang: props.blockLang && props.blockLang !== '' ? props.blockLang : null,
            'aria-label': props.ariaLabel && props.ariaLabel !== '' ? props.ariaLabel : null
        };
        if (offDomain) {
            linkProps.rel = 'noreferrer';
        }
        if (props.download)
            linkProps.download = true;
        // Normal link, Black link
        link = react_1.default.createElement("a", Object.assign({}, linkProps), props.title);
        // Primary button
        if (props.type === LinkType.Primary_button || props.type === LinkType.Transparent_button
            || props.type === LinkType.Transparent_button_blue || props.type === LinkType.Outline_Button) {
            if (props.icon_front)
                link = react_1.default.createElement("a", Object.assign({}, linkProps),
                    react_1.default.createElement("span", { className: `position-relative front ${props.icon_class}` }),
                    react_1.default.createElement("span", { className: 'position-relative' }, props.title));
            else
                link = react_1.default.createElement("a", Object.assign({}, linkProps),
                    react_1.default.createElement("span", { className: 'position-relative' }, props.title),
                    react_1.default.createElement("span", { className: `position-relative ${props.icon_class}` }));
            return link;
        }
        // Icon link
        if ((props.type === LinkType.Icon_link || props.type === LinkType.Icon_link_between) && props.icon_class !== null) {
            if (props.icon_front)
                link = react_1.default.createElement("a", Object.assign({}, linkProps),
                    react_1.default.createElement("span", { className: `${props.icon_class} front` }),
                    props.title);
            else
                link = react_1.default.createElement("a", Object.assign({}, linkProps),
                    props.title,
                    react_1.default.createElement("span", { className: props.icon_class }));
            return link;
        }
        // Download link with type 
        if (props.type === LinkType.Download_link_with_type) {
            let docType = props.documentType;
            try {
                if (props.download && (docType === null || docType === undefined))
                    docType = linkProps.href.substring(linkProps.href.lastIndexOf('.') + 1);
                if (docType.length > 4)
                    docType = '';
            }
            catch (_d) {
                //nothing
            }
            linkProps.className = `${linkProps.className} d-flex align-items-center ${props.additionalCssClasses && props.additionalCssClasses.length > 0 && props.additionalCssClasses.join(' ')}`;
            link = react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", { className: 'icon-download pe-2' }),
                react_1.default.createElement("span", { className: 'visually-hidden' }, `${lang === 'en' ? 'download' : 'lataa'}`),
                react_1.default.createElement("span", null, props.title),
                react_1.default.createElement("span", { className: 'ps-2 type' }, docType));
            return link;
        }
        // Download_link_with_type_under
        if (props.type === LinkType.Download_link_with_type_under) {
            let docType = props.documentType;
            try {
                if (docType === null || docType === undefined)
                    docType = linkProps.href.substring(linkProps.href.lastIndexOf('.') + 1);
            }
            catch (_e) {
                //nothing
            }
            linkProps.className = `${linkProps.className} d-flex align-items-center flex-wrap ${props.additionalCssClasses && props.additionalCssClasses.length > 0 && props.additionalCssClasses.join(' ')}`;
            link = react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", { className: 'd-block w-100' },
                    react_1.default.createElement("span", null, props.title),
                    react_1.default.createElement("span", { className: 'icon-download ps-2' }),
                    react_1.default.createElement("span", { className: 'visually-hidden' }, `${lang === 'en' ? 'download' : 'lataa'}`)),
                react_1.default.createElement("span", { className: 'd-block w-100 type text-black' }, docType));
            return link;
        }
        // Document lift-up
        if (props.type === LinkType.Document_liftup_icon) {
            let docType = props.documentType;
            const styles = {
                minHeight: props.lineHeight && props.lineHeight > 0 ? `${props.lineHeight}rem` : ''
            };
            try {
                if (docType === null || docType === undefined)
                    docType = linkProps.href.substring(linkProps.href.lastIndexOf('.') + 1);
            }
            catch (_f) {
                //nothing
            }
            linkProps.className = `${linkProps.className} d-flex align-items-center justify-content-between p-6 ${props.additionalCssClasses && props.additionalCssClasses.length > 0 && props.additionalCssClasses.join(' ')}`;
            link = react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", null,
                    react_1.default.createElement("span", { className: `d-block ${props.lineHeight && props.lineHeight > 0 ? 'two-lined' : 'lh-sm text-break'} pt-1`, style: styles }, props.title),
                    react_1.default.createElement("span", { className: 'pe-2 type text-uppercase' }, docType)),
                react_1.default.createElement("span", { className: 'icon-download ps-2' },
                    react_1.default.createElement("span", { className: 'visually-hidden' }, `${lang === 'en' ? 'download' : 'lataa'}`)));
            return link;
        }
        if (props.type === LinkType.Link_with_selectable_icon_front) {
            link = react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", { className: `${props.icon_class} pe-3` }),
                props.title);
            return link;
        }
        if (props.type === LinkType.Icon_link_with_underline && props.icon_class) {
            linkProps.className = `${linkProps.className} d-flex align-items-center justify-content-between p-3 w-100 py-7 ${props.additionalCssClasses && props.additionalCssClasses.length > 0 && props.additionalCssClasses.join(' ')}`;
            link = react_1.default.createElement("a", Object.assign({}, linkProps),
                props.title,
                react_1.default.createElement("span", { className: `${props.icon_class}` }));
            return link;
        }
    }
    else {
        console.error('Invalid link type settings.');
    }
    return link;
};
exports.SampoLink = SampoLink;
exports.default = exports.SampoLink;
